import React, { useState, FC } from 'react';

interface IContextState {
  currentStep: number;
  setCurrentStep: (step: number) => void;
  totalSteps: number;
  setTotalSteps: (steps: number) => void;
  resetWizardState: () => void;
}

export const WizardContext = React.createContext<IContextState>({
  currentStep: 1,
  setCurrentStep: () => {},
  totalSteps: 5,
  setTotalSteps: () => {},
  resetWizardState: () => {},
});

interface IProps {
  children: React.ReactNode;
}

export const WizardProvider: FC<IProps> = ({ children }: IProps) => {
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [totalSteps, setTotalSteps] = useState<number>(5);

  const resetWizardState = () => {
    setCurrentStep(1);
    setTotalSteps(5);
  };

  return (
    <WizardContext.Provider
      value={{
        currentStep,
        setCurrentStep,
        totalSteps,
        setTotalSteps,
        resetWizardState,
      }}
    >
      {children}
    </WizardContext.Provider>
  );
};

export function useWizardContext(): IContextState {
  return React.useContext(WizardContext);
}
